<script>
    import {logout } from '../service'
    logout()
    $$props.router.navigate('home')
</script>